import { eHierarchy, eHierarchyLevel } from "functions/api/enums";

/**
 * Gets the prefix character for a hierarchy or hierarchy level type.
 *
 * @param type - The hierarchy or hierarchy level type
 * @returns The prefix character ("R" for Report, "S" for Study, "H" for others)
 */
export const getHierarchyPrefix = (type: eHierarchy | eHierarchyLevel | undefined): string => {
  switch (type) {
    case eHierarchyLevel.Report:
    case eHierarchy.Report:
      return "R";
    case eHierarchyLevel.Study:
    case eHierarchy.StudyDirectory:
      return "S";
    case eHierarchy.Directory:
    case eHierarchy.TopLevel:
    case eHierarchyLevel.TopLevel:
    case eHierarchyLevel.Corporate:
    case eHierarchyLevel.TA:
    case eHierarchyLevel.Project:
    case undefined:
    default:
      return "H";
  }
};
